<template>
    <div>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
        <b-form @submit="onSubmitFormSearch">
            <b-form-row>
                <b-form-group class="col-sm-12 col-md-5" label="API">
                    <b-form-select
                        v-model="apiSelected"
                        :options="apiOpts"
                    ></b-form-select>
                </b-form-group>

                <b-form-group class="col-sm-12 col-md-5 mb-3" label="Reference ID">
                    <b-form-input
						type="number"
						required
                        v-model="referenceId"
                    ></b-form-input>
                </b-form-group>

                <div class="col-sm-12 col-md-2 d-flex flex-row align-items-end">
                    <b-button
                        type="submit"
                        variant="primary"
                        class="w-100 u:h-fit-content u:mb-2"
                        >Buscar</b-button
                    >
                </div>
            </b-form-row>
        </b-form>

        <hr />

        <div v-if="bookingInfo">
            <b-alert show variant="secondary">
				<div class="w-100 d-flex justify-content-between">
					<h5>Reference ID: {{idSearching}}</h5>
					<span class="text-right small"><b-badge :variant="statusColor">{{bookingStatus}}</b-badge></span>
				</div>
				<hr>
                <pre>{{ bookingInfo }}</pre>
            </b-alert>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
			bookingInfo: null,
			referenceId: '',
            apiSelected: "jayride",
            bookingStatus: '',
            statusColor: '',
            apiOpts: [{ value: "jayride", text: "Jayride" }],
            loading: true,
			idSearching: '',
        };
    },
    mounted() {
		this.loading = false
	},
    methods: {
        onSubmitFormSearch(event) {
            event.preventDefault();
            this.loading = true;
			this.bookingInfo = null

            this.$root.api
                .post(`/api-reservation`, {
					api: this.apiSelected,
					referenceId: this.referenceId,
				})
                .then((res) => {
					this.loading = false;
					this.bookingInfo = res.data.booking
					this.bookingStatus = res.data.status
					this.idSearching = this.referenceId

					// color status
                    if (this.bookingStatus == "active") {
                        this.statusColor = "success";
                    } else if (this.bookingStatus == "canceled") {
                        this.statusColor = "danger";
                    }
                })
                .catch(this.$root.handleRequestError)
                .then(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
